"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { cn } from "@repo/design-system/utils/cn";
import type { ReactNode } from "react";
import BenefitsIcon from "~/components/icons/benefits-econ";
import BuildingEcon from "~/components/icons/building-econ";
import CultureEcon from "~/components/icons/culture-econ";
import LaptopEcon from "~/components/icons/laptop-econ";
import RestassuredEcon from "~/components/icons/restassured-econ";
import WecareEcon from "~/components/icons/wecare-econ";
import WedriveEcon from "~/components/icons/wedrive-econ";
import WegrowEcon from "~/components/icons/wegrow-econ";
import { buttonVariants } from "~/components/ui/button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
interface Benefit {
  icon: ReactNode;
  text: string;
  title: string;
}
const entryLevel = ["Praktikant:in", "Internship", "Werkstudierende", "Working Student"];
interface BenefitsEconProps {
  job: Job;
}
export default function BenefitsEcon(t0) {
  const $ = _c(42);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== job.data.entryLevel || $[1] !== t.econ_benefit_href || $[2] !== t.econ_benefit_href_title || $[3] !== t.econ_benefits_internship_text1 || $[4] !== t.econ_benefits_internship_text2 || $[5] !== t.econ_benefits_internship_text3 || $[6] !== t.econ_benefits_internship_text4 || $[7] !== t.econ_benefits_internship_title1 || $[8] !== t.econ_benefits_internship_title2 || $[9] !== t.econ_benefits_internship_title3 || $[10] !== t.econ_benefits_internship_title4 || $[11] !== t.econ_benefits_text1 || $[12] !== t.econ_benefits_text2 || $[13] !== t.econ_benefits_text3 || $[14] !== t.econ_benefits_text4 || $[15] !== t.econ_benefits_text5 || $[16] !== t.econ_benefits_text6 || $[17] !== t.econ_benefits_title1 || $[18] !== t.econ_benefits_title2 || $[19] !== t.econ_benefits_title3 || $[20] !== t.econ_benefits_title4 || $[21] !== t.econ_benefits_title5 || $[22] !== t.econ_benefits_title6) {
    const isInternship = entryLevel.includes(job.data.entryLevel);
    const benefitsRegular = [{
      icon: <WegrowEcon className="h-20" />,
      title: t.econ_benefits_title1,
      text: t.econ_benefits_text1
    }, {
      icon: <WedriveEcon className="h-20" />,
      title: t.econ_benefits_title2,
      text: t.econ_benefits_text2
    }, {
      icon: <WecareEcon className="h-20" />,
      title: t.econ_benefits_title6,
      text: t.econ_benefits_text6
    }, {
      icon: <CultureEcon className="h-20" />,
      title: t.econ_benefits_title3,
      text: t.econ_benefits_text3
    }, {
      icon: <BenefitsIcon className="h-20" />,
      title: t.econ_benefits_title4,
      text: t.econ_benefits_text4
    }, {
      icon: <RestassuredEcon className="h-20" />,
      title: t.econ_benefits_title5,
      text: t.econ_benefits_text5
    }];
    const benefitsInternship = [{
      icon: <BuildingEcon className="h-20" />,
      title: t.econ_benefits_internship_title1,
      text: t.econ_benefits_internship_text1
    }, {
      icon: <WegrowEcon className="h-20" />,
      title: t.econ_benefits_internship_title2,
      text: t.econ_benefits_internship_text2
    }, {
      icon: <CultureEcon className="h-20" />,
      title: t.econ_benefits_internship_title3,
      text: t.econ_benefits_internship_text3
    }, {
      icon: <LaptopEcon className="h-20" />,
      title: t.econ_benefits_internship_title4,
      text: t.econ_benefits_internship_text4
    }];
    const benefits = isInternship ? benefitsInternship : benefitsRegular;
    t5 = "outer-container py-container print:hidden";
    t6 = "benefits";
    t3 = "inner-container grid h-full justify-center";
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <h2 className="mb-10 text-center font-bold text-4xl text-black xl:mb-20 xl:text-5xl">Benefits</h2>;
      t1 = cn("grid grid-flow-row grid-cols-1 gap-4 md:gap-6 lg:grid-cols-3 lg:gap-10");
      $[29] = t1;
      $[30] = t4;
    } else {
      t1 = $[29];
      t4 = $[30];
    }
    t2 = benefits.map(benefit => <div className={cn("flex flex-col justify-between gap-y-4 break-words bg-[#f7e8da] p-8 text-foreground transition-all md:gap-y-6 lg:p-12", benefit.title === "On-Site Benefits" && "col-span-full flex-row gap-6")} key={benefit.title}><div className="grid items-center justify-start gap-x-4 gap-y-6 lg:grid-flow-row"><span>{benefit.icon}</span><p className={cn("font-black text-3xl leading-10 md:min-h-[80px] lg:text-4xl", isInternship && "md:min-h-[120px]")}>{benefit.title}</p><div className={cn("ml-4 text-base sm:text-lg xl:text-xl [&_li]:mb-1 [&_ul]:list-disc", benefit.title === "On-Site Benefits" && "[&_ul]:grid [&_ul]:lg:max-h-[160px] [&_ul]:lg:grid-cols-2 [&_ul]:lg:grid-rows-5")} dangerouslySetInnerHTML={{
          __html: benefit.text
        }} /></div>{benefit.title === t.econ_benefits_title1 && <CustomLink blank={true} className={cn(buttonVariants({
        variant: "default"
      }), "rounded-[14px]! border-primary text-lg hover:border-[#9d1207] hover:bg-[#9d1207] hover:text-white")} href={t.econ_benefit_href}>{t.econ_benefit_href_title}</CustomLink>}</div>);
    $[0] = job.data.entryLevel;
    $[1] = t.econ_benefit_href;
    $[2] = t.econ_benefit_href_title;
    $[3] = t.econ_benefits_internship_text1;
    $[4] = t.econ_benefits_internship_text2;
    $[5] = t.econ_benefits_internship_text3;
    $[6] = t.econ_benefits_internship_text4;
    $[7] = t.econ_benefits_internship_title1;
    $[8] = t.econ_benefits_internship_title2;
    $[9] = t.econ_benefits_internship_title3;
    $[10] = t.econ_benefits_internship_title4;
    $[11] = t.econ_benefits_text1;
    $[12] = t.econ_benefits_text2;
    $[13] = t.econ_benefits_text3;
    $[14] = t.econ_benefits_text4;
    $[15] = t.econ_benefits_text5;
    $[16] = t.econ_benefits_text6;
    $[17] = t.econ_benefits_title1;
    $[18] = t.econ_benefits_title2;
    $[19] = t.econ_benefits_title3;
    $[20] = t.econ_benefits_title4;
    $[21] = t.econ_benefits_title5;
    $[22] = t.econ_benefits_title6;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
  } else {
    t1 = $[23];
    t2 = $[24];
    t3 = $[25];
    t4 = $[26];
    t5 = $[27];
    t6 = $[28];
  }
  let t7;
  if ($[31] !== t1 || $[32] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[31] = t1;
    $[32] = t2;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t3 || $[35] !== t4 || $[36] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[34] = t3;
    $[35] = t4;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t5 || $[39] !== t6 || $[40] !== t8) {
    t9 = <section className={t5} id={t6}>{t8}</section>;
    $[38] = t5;
    $[39] = t6;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
}